module.exports = __webpack_public_path__ + "static/media/sales-stream-summary.71f3212d.svg";